import { ComponentPropsWithoutRef } from 'react'

import { useRouter } from 'next/router'

import { getBaseUrl, resolveArticleSlug, resolveParentArticles } from '@/lib/contentful/utils'

import getLocalizedNameFromEnglish from '@/utils/locales/localized-routes/getLocalizedNameFromEnglish'
import getLocalizedPathFromEnglish from '@/utils/locales/localized-routes/getLocalizedPathFromEnglish'

import { Breadcrumbs } from '@/components/Breadcrumbs'
import { Warning } from '@/components/Warning'

import { useEntry } from '../Article.hooks'

export function ArticleBreadcrumbs(
	props: Omit<ComponentPropsWithoutRef<typeof Breadcrumbs>, 'breadcrumbs' | 'currentPage'>
) {
	const { locale = 'en-US' } = useRouter()
	const entry = useEntry()

	if ('error' in entry) {
		return <Warning className={props.className}>{entry.error}</Warning>
	}

	const articles = resolveParentArticles(entry.data)

	return (
		<Breadcrumbs
			{...props}
			dataTestid="article-breadcrumbs"
			breadcrumbs={[
				{
					text: 'Homepage',
					schemaUrl: `${getBaseUrl(locale)}/`,
					seoOnly: true
				},
				{
					text: getLocalizedNameFromEnglish({ locale, name: 'articles', capitalized: true }),
					link: { href: getLocalizedPathFromEnglish(locale, '/articles/') },
					schemaUrl: `${getBaseUrl(locale)}${getLocalizedPathFromEnglish(locale, '/articles/')}`
				},
				...articles
					.slice()
					.reverse()
					.map((parent) => ({
						text: parent.title,
						link: {
							href: `${getLocalizedPathFromEnglish(locale, '/articles/')}${resolveArticleSlug(
								parent
							)}/`
						},
						schemaUrl: `${getBaseUrl(locale)}${getLocalizedPathFromEnglish(locale, '/articles/')}${
							parent.slug
						}/`
					}))
			]}
			currentPage={entry.data.title}
		/>
	)
}
